import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { canvasEditorOptions, ElementAttribute, ElementTagName, functionLables } from '@models/editor';
import { CanvasInputMode, CanvasInputModeService } from '@service/canvas/canvas-input-mode.service';
import { Mimic } from 'icreate/common/models/mimic';
import { RootItem } from 'icreate/common/models/mimic-folder';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-design-side-menu',
    templateUrl: './design-side-menu.component.html',
    styleUrls: ['./design-side-menu.component.css'],
    standalone: false,
})
export class DesignSideMenuComponent implements OnInit, OnDestroy {
    readonly ENTITY_TEXT = canvasEditorOptions.text;
    readonly ENTITY_MOVE = functionLables.move;

    @Input() selectedMimic: Mimic;
    @Input() selectedElements: SVGElement[];
    @Input() rootList: RootItem[];

    currentMode: CanvasInputMode;

    private destroySubscriptionSubject$ = new Subject<void>();

    constructor(private canvasModeService: CanvasInputModeService) {}

    ngOnInit(): void {
        this.canvasModeService
            .onModeChanged()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe(mode => {
                this.currentMode = mode;
            });
    }

    ngOnDestroy(): void {
        this.destroySubscriptionSubject$.next();
        this.destroySubscriptionSubject$.complete();
    }

    showCanvasOptions(): boolean {
        return this.selectedElements.length === 0 && !!this.selectedMimic;
    }

    showTextOptions(): boolean {
        if (this.currentMode === CanvasInputMode.TEXT) {
            return true;
        }
        return this.selectedElements.length === 1 && this.selectedElements[0]?.tagName === ElementTagName.text;
    }

    showShapeOptions(): boolean {
        return (
            this.currentMode !== CanvasInputMode.CONNECTOR &&
            this.currentMode !== CanvasInputMode.COMMENT &&
            this.selectedElements.length > 0
        );
    }

    showCornerRadius(): boolean {
        if (this.selectedElements.length > 1) return false;
        if (this.selectedElements.length === 1) {
            if (
                this.selectedElements[0].tagName === ElementTagName.rect ||
                this.selectedElements[0].getAttribute(ElementAttribute.type) === CanvasInputMode.TRIANGLE ||
                this.selectedElements[0].getAttribute(ElementAttribute.type) === CanvasInputMode.RECTANGLE
            )
                return true;

            if (this.selectedElements[0].getAttribute(ElementAttribute.type)) return false;
            if (this.selectedElements[0].tagName !== ElementTagName.path) return false;
            return false;
        }
        return false;
    }

    hideAppearanceOption(): boolean {
        if (this.selectedElements.length === 1) {
            if (this.selectedElements[0].tagName === ElementTagName.image) return true;
        }

        return false;
    }

    isGroup(): boolean {
        if (this.selectedElements.length === 1) {
            const el = this.selectedElements[0];
            if (el.tagName === ElementTagName.g) {
                if (el.getAttribute(ElementAttribute.type) || el.getAttribute(ElementAttribute.resizable)) {
                    return false;
                }
                return true;
            }
        }

        return false;
    }
}
